import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { studentsReceiptFetch } from '../../../../api-client/api-gqadmin-client';
import { CustomButton, CustomTable } from '../../../atoms';
import { downloadPDF, rupeeNumberFormatter, showErrorToast } from '../../../../utils/utils';
import classes from './DirectPaymentTable.module.scss';
import { ANALYTICS_EVENTS } from '../../../../utils/constants';
import { sendAnalytics } from '../../../../analytics';

const DirectPaymentTable = (props) => {
    const { tableData, isLoading, selectedStudentId } = props;
    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadingIndex, setDownloadingIndex] = useState(null);

    const handleDownload = async (data, index) => {
        try {
            setDownloadingIndex(index);
            setIsDownloading(true);
            const receiptDownloadPayload = {
                application_code: data?.transaction_id || '',
                sbd_code: selectedStudentId?.value || '',
                payment_mode: data?.transactions?.[0]?.payment_mode || '',
                receipt: true,
            };
            const studentsReceiptDownloadRes = await studentsReceiptFetch(receiptDownloadPayload);
            downloadPDF(studentsReceiptDownloadRes?.data?.data, 'Transaction Receipt');
            sendAnalytics({
                vendor: ['mixpanel', 'ga'],
                eventData: {
                    event: ANALYTICS_EVENTS.PP_RCPT_DOWNLOAD,
                    trackingData: {
                        student_uuid: selectedStudentId?.student_uuid,
                        financing_mode: data?.transactions?.[0]?.payment_mode || '',
                        status: 'success'
                    }
                }
            })
        } catch (error) {
            showErrorToast(
                'We are facing an error downloading the receipt at this moment, Please contact support@grayquest.com',
            );
            console.error('Error in downloading direct payment receipt', error);
            sendAnalytics({
                vendor: ['mixpanel', 'ga'],
                eventData: {
                    event: ANALYTICS_EVENTS.PP_RCPT_DOWNLOAD,
                    trackingData: {
                        student_uuid: selectedStudentId?.student_uuid,
                        financing_mode: data?.transactions?.[0]?.payment_mode || '',
                        status: 'failed'
                    }
                }
            })
        } finally {
            setIsDownloading(false);
        }
    };

    const renderTableBodyRows = (tableRowData) => {
        if (Array.isArray(tableRowData) && tableRowData?.length === 0) return;
        return (
            <>
                {tableRowData.map((item, index) => {
                    return (
                        <tr key={index}>
                            <td style={{ width: '10%' }}>{index + 1}</td>
                            <td style={{ width: '22%' }}>{item?.transaction_id ?? '-'}</td>
                            <td style={{ width: '16%' }}>{item?.transaction_date ?? '-'}</td>
                            <td style={{ width: '16%', textAlign: 'center' }}>
                                {rupeeNumberFormatter(item?.total)}
                            </td>
                            <td style={{ width: '16%', textAlign: 'center' }}>
                                {item?.transactions?.[0]?.payment_mode ?? '-'}
                            </td>
                            <td style={{ width: '20%', textAlign: 'center' }}>
                                <div className={classes.FormAction}>
                                    {item?.status?.toLowerCase() !== 'paid' && (
                                        <CustomButton
                                            type="submit"
                                            text="Download Receipt"
                                            onClick={() => handleDownload(item, index)}
                                            title="Download Receipt"
                                            variant="outline"
                                            className={classes.SubmitButton}
                                            isLoading={
                                                downloadingIndex === index ? isDownloading : false
                                            }
                                        />
                                    )}
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </>
        );
    };

    return (
        <CustomTable isLoading={isLoading} noDataAvailable={tableData?.length === 0}>
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Transaction Id</th>
                    <th>Transaction Date</th>
                    <th style={{ textAlign: 'center' }}>Amount Paid</th>
                    <th style={{ textAlign: 'center' }}>Payment Mode</th>
                    <th style={{ textAlign: 'center' }}>Actions</th>
                </tr>
            </thead>
            <tbody>{renderTableBodyRows(tableData?.[0]?.transaction_details ?? [])}</tbody>
        </CustomTable>
    );
};

DirectPaymentTable.propTypes = {
    tableData: PropTypes.array,
    isLoading: PropTypes.bool,
    selectedStudentId: PropTypes.object,
};

export default DirectPaymentTable;
